import { render, staticRenderFns } from "./PaymentMethodsAdd.vue?vue&type=template&id=d2d942c6&"
import script from "./PaymentMethodsAdd.vue?vue&type=script&lang=js&"
export * from "./PaymentMethodsAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports